import AddIcon from "@mui/icons-material/Add"
import { Box, Typography } from "@mui/material"
import React from "react"
import DefaultBsProjectCard from "../../../../../../../../assets/DefaultBsProjectCard.svg"
import { customPalette, theme } from "../../../../../../../../theme"
import { BaseButton } from "../../../../../../../components/buttons/BaseButton"

interface IProps {
  setOpenCreateBuildingForm: React.Dispatch<React.SetStateAction<boolean>>
}

export function BSBuildingListEmpty({ setOpenCreateBuildingForm }: Readonly<IProps>): React.JSX.Element {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        flexGrow: 1,
      }}>
      <Box
        sx={{
          width: 60,
          height: 60,
          backgroundColor: theme.palette.common.white,
          borderRadius: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 2,
          boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
        }}>
        <Box
          component="img"
          src={DefaultBsProjectCard}
          sx={{
            width: "85%",
            height: "85%",
            objectFit: "cover",
          }}
        />
      </Box>

      <Typography
        variant="subtitle1"
        textAlign="center"
        fontSize={22}
        sx={{ marginBottom: 2, color: customPalette.darkBlue3 }}>
        Aucun bâtiment
      </Typography>

      <Typography variant="body2" textAlign="center" sx={{ marginBottom: 3, maxWidth: "80%" }}>
        Ajouter un bâtiment et lancez votre estimation carbone
      </Typography>

      <BaseButton onClick={() => setOpenCreateBuildingForm(true)} label="Ajouter un bâtiment" icon={AddIcon} />
    </Box>
  )
}
